import React from "react";
import TopNavbarBack from "../../components/TopNavbarBack";
import "../../styles/Banners.css";
import "../../styles/Fonts.css"
import "../../styles/Containers.css"
import "../../styles/Colors.css"
import How1 from "../../media/How_FP/How1.png"
import How2 from "../../media/How_FP/How2.png"
import How3 from "../../media/How_FP/How3.png"
import GoToTop from "../../components/GoToTop";

export default function TutorialHow() {
  return (
    <div className="backLightColor">
      <TopNavbarBack
          title=""
          rbuttonIcon={["icon-iconchevron-right"]}
          rbackground={["rectangle"]}
          lbuttonIcon={["dNone"]}
          lbuttonHref={["null"]}
          lbackground={["dNone"]}
        />
      <div className="tutorial">

        <h2>چگونه از فودپلنر استفاده کنم؟ </h2>
        <p>این برنامه بهت کمک می‌کنه دیگه نپرسی چی درست کنم غذاها و میان وعده‌هاتو انتخاب می‌کنی، توی روزی که می‌خوای می‌گذاری و هر شب بهت یادآوری میشه فردا چی داری!</p>
        <br />

        <div className="b-blue20perc grey-1 paddingSide5 paddingTop1 paddingButtom5 radius1">
        <h2>این کار خیلی ساده است :</h2>
          <li>1.&nbsp;برو توی تب تقویم </li>
          <br/>
          <li>2.&nbsp;روز وعده رو پیدا کن</li>
          <br/>
          <li>3.&nbsp;روی علامت + بزن</li>
          <div className="centerd">
          <img
          className="radius1 box50perc shadow-normal"	
					src={How1}
					alt='how1'
				  />
          </div>
          <li>4.&nbsp;حالا غذا رو پیدا کن و علامت + توی کارت غذا رو بزن</li>
          <div className="centerd">
          <img
          className="radius1 box50perc shadow-normal"	
					src={How2}
					alt='how2'
				  />
          </div>
          <li>5.&nbsp;تایید کن که می‌خوای این غذا رو توی همین وعده بذاری و منتظر وقتش باش که شروع کنی برای پختن غذای خوشمزت</li>
          <div className="centerd">
          <img
          className="radius1 box50perc shadow-normal"	
					src={How3}
					alt='how3'
				  />
          </div>
        </div>
      </div>
      <GoToTop />
    </div>
  );
}
